export enum VolumeAllocationCodes {
  // Error Codes
  DA_001 = 'DA_001',
  DA_002 = 'DA_002',
  DA_003 = 'DA_003',
  DA_004 = 'DA_004',
  DA_005 = 'DA_005',

  // Requested Volume Exeeds Quota Tolerance
  DA_009 = 'DA_009',

  // Weekends
  DA_010 = 'DA_010',

  // Before Volume Requested Exeeds Quota Tolerance
  DA_011 = 'DA_011',
}

export enum VolumeAllocationMessageResponse {
  REQUESTED_VOLUME_EXEEDS_QUOTA_TOLERANCE = 'By.Requested.Volume.Exeeds.Quota.Tolerance',
  BEFORE_VOLUME_REQUESTED_EXEEDS_QUOTA_TOLERANCE = 'Before.Volume.Requested.Exeeds.Quota.Tolerance',
  ERROR_MESSAGE = 'volume.validation.error.message',
}
export const VolumeAllocationErrorCodes = [
  VolumeAllocationCodes.DA_001,
  VolumeAllocationCodes.DA_002,
  VolumeAllocationCodes.DA_003,
  VolumeAllocationCodes.DA_005,
];
